import { Box } from '@mui/material';
import { MyClientsListProps, UserInfo } from './types';
import ClientRowMobile from './ClientRowMobile';
//https://stackoverflow.com/questions/71864100/mui-datagrid-responsive-mobile-layout

const groupUsersBySender = (users: any[]) => {
  let result = {
    senders: [] as UserInfo[],
    groups: {} as Record<string, UserInfo[]>,
  };
  users.forEach((user) => {
    let sender = { id: 'unknown', name: 'Unknown', phone: '' };
    let receiver = null;
    if (user.senderRegisteredUser) {
      sender = {
        id: user.senderRegisteredUser.id,
        name: user.senderRegisteredUser.name,
        phone: user.senderRegisteredUser.phone,
      };
      receiver = {
        id: user.id,
        name: user.name,
        phone: user.phone,
      };
    } else {
      sender = {
        id: user.id,
        name: user.name,
        phone: user.phone,
      };
    }

    if (!result.groups[sender.id]) {
      result.groups[sender.id] = [];
    }
    if (receiver) {
      result.groups[sender.id].push(receiver);
    }
    if (!result.senders.find((s) => s.id === sender.id))
      result.senders.push(sender);
  });
  return result;
};

const MyClientListMobile = (props: MyClientsListProps) => {
  const users = props.query?.users;
  const grouped = groupUsersBySender(users || []);
  return (
    <>
      {users && (
        <Box sx={{ padding: 2 }}>
          {grouped.senders.map((sender) => (
            <Box key={`sender_${sender.id}`} sx={{ paddingBottom: 2 }}>
              <ClientRowMobile
                key={sender.id}
                sender={sender}
                receipients={grouped.groups[sender.id] || []}
              />
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default MyClientListMobile;
